<template>
    <template v-if="brandsCollection.count.value > 0">
        <flex-container>
            <flex-container>
                <flex-container :size="5">
                    <text-heading>
                        {{ t('heading') }}
                    </text-heading>
                </flex-container>
                <flex-container :size="5" justify-content="flex-end">
                    <add-brand-button />
                </flex-container>
            </flex-container>
            <inline-tabs selected-name="brands">
                <template #labels>
                    <inline-tab-label name="teams" @click="$router.push({ name: 'team-list' })">
                        {{ t('tabTeams') }}
                    </inline-tab-label>
                    <inline-tab-label name="brands">
                        {{ t('tabBrands') }}
                    </inline-tab-label>
                </template>
                <template #panels>
                    <inline-tab-panel name="brands">
                        <card-normal without-padding :with-overflow="false">
                            <brand-list :brands="brandsCollection" />
                        </card-normal>

                        <flex-container justify-content="center">
                            <flex-container :size="3" padding="xl">
                                <making-art-icon />
                            </flex-container>
                        </flex-container>
                    </inline-tab-panel>
                </template>
            </inline-tabs>
        </flex-container>
    </template>

    <template v-else>
        <brand-collection-empty-message />
    </template>

    <router-view />
</template>

<script setup lang="ts">
    import MakingArtIcon from '@/assets/icons/undraw/making_art.svg?component';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import BrandCollectionEmptyMessage from '@/company/brand/components/BrandCollectionEmptyMessage.vue';
    import { Brand } from '@keyvue/one-api-client';
    import AddBrandButton from '@/company/brand/components/AddBrandButton.vue';
    import BrandList from '@/company/brand/components/BrandList.vue';
    import useEventBus from '@/services/eventbus/composables/useEventBus';
    import BrandDeletedEvent from '@/company/brand/events/BrandDeletedEvent';
    import { useI18n } from 'vue-i18n';
    import messages from './BrandListView.messages.json';

    const { t } = useI18n({ messages });

    const { getLazyResourceCollection } = useClient();
    const eventBus = useEventBus();

    const brandsCollection = getLazyResourceCollection(Brand);

    async function loadBrands() {
        await brandsCollection.load();
    }

    await loadBrands();

    eventBus.subscribe(
        BrandDeletedEvent,
        loadBrands,
    );
</script>
